module.exports = __webpack_public_path__ + "static/img/reset_filter.c5df57d3.svg";